'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlOnFileDrag', function (fileDropUtils) {
  return {
    restrict: 'A',
    link: function link($scope, $el, $attrs) {
      var configAttribute = $attrs.tlOnFileDrag;
      var unbindHandler = null;
      $scope.$watch(configAttribute, function (configOrHandler) {
        if (unbindHandler != null) {
          unbindHandler();
        }
        if (configOrHandler == null) {
          return;
        }
        var onEnter, onLeave;
        if (_.isFunction(configOrHandler)) {
          onEnter = configOrHandler;
          onLeave = angular.noop;
        } else {
          onEnter = configOrHandler.onEnter;
          onLeave = configOrHandler.onLeave;
        }
        unbindHandler = fileDropUtils.addFileDragEvents($el, $scope, onEnter, onLeave);
      });
      $scope.$on('$destroy', function () {
        if (unbindHandler != null) {
          unbindHandler();
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/drag-n-drop/tl-on-file-drag.js
// module id = 2933
// module chunks = 13